import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
} from 'react-router-dom';

import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import * as routes from '../constants/routes';

import propertySearch from './propertySearch/propertySearch';



const ME_QUERY = gql`
  query me {
    me{
      id
      name
      email
    }
  }
`;

class Main extends Component {



  constructor(props) {
    super(props);
  }



  toggleRightSideMenu = () => {
    this.setState({ showRightSideMenu: !this.state.showRightSideMenu });
  }

  render() {
      return(
          <Query query={ME_QUERY}>
          {({ data, loading, error }) => {
            if(!loading){
              // console.log(data);
            }
            return(
              <Router>
                <div className="be-wrapper">
                  <Route
                    exact path='/'
                    component={propertySearch}
                  />
                </div>
              </Router>

            )
          }}
          </Query>

      )


  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js